import type { Ref } from "react";
import { forwardRef, memo } from "react";
import clsx from "clsx";

import classes from "./styles.module.scss";

import type { IBoxProps } from ".";

export const Box = memo(
  forwardRef(function Box(props: IBoxProps, ref: Ref<HTMLDivElement>) {
    const {
      radius = "12",
      px,
      py,
      pb,
      pe,
      ps,
      pt,
      padding,
      className,
      children,
      noBorder,
      gridGap,
      backgroundColor = "bg-white-0",
      borderWithColor = "stroke-soft-200",
      ...htmlAttribute
    } = props;

    return (
      <div
        ref={ref}
        className={clsx([
          px && `px-${px}`,
          py && `py-${py}`,
          pt && `pt-${py}`,
          pb && `pb-${py}`,
          ps && `ps-${py}`,
          pe && `pe-${py}`,
          padding && `p-${padding}`,
          `rounded-${radius}`,
          `bg-color-${backgroundColor}`,
          noBorder !== true && `border-${borderWithColor}`,
          gridGap && `d-grid gap-${gridGap}`,
          className,
          classes.box,
        ])}
        {...htmlAttribute}
      >
        {children}
      </div>
    );
  }),
);

Box.displayName = "Box";
